import React from "react";
import { WidgetConfigurationContext, } from "./configuration";
// eslint-disable-next-line @typescript-eslint/ban-types
export class WebComponentErrorBoundary extends React.Component {
    // eslint-disable-next-line @typescript-eslint/ban-types
    constructor(props) {
        super(props);
        this.state = { error: undefined };
    }
    static getDerivedStateFromError(error) {
        return { error };
    }
    componentDidCatch(error, errorInfo) {
        // We know the context is correctly set because the framework always provides a value.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.context.widgetConfiguration.error(`Error thrown`, error, errorInfo);
    }
    render() {
        return this.state.error ? (<>
        <p>An error occured in rendering this widget</p>
        <small>
          <code>{this.state.error}</code>
        </small>
      </>) : (<>{this.props.children}</>);
    }
}
WebComponentErrorBoundary.contextType = WidgetConfigurationContext;
